<template>
  <div>
    <div v-show="requirements.length" class="show-link" @click="toggleShow">
      {{ show ? "Hide" : "Show" }} Regulatory Update History ({{
        requirements.length
      }})
    </div>
    <div v-show="show" class="history-wrapper">
      <div v-for="(hist, index) in requirements" :key="index">
        <h2 class="heading" style="margin-top: 20px">
          {{ hist.title }}
        </h2>
        <h2 class="date">
          {{ fixDate(hist.publishDate) }}
        </h2>
        <!-- eslint-disable vue/no-v-html -->
        <div class="history-wrapper__content" v-html="hist.content" />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>
</template>

<script>
import { months } from "../../config";
export default {
  name: "RequirementHistory",
  components: {},
  props: {
    requirements: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      months,
      show: false,
    };
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    fixDate(val) {
      let date = "";
      if (val) {
        const text = val.trim();
        const newText = text.substring(0, 10).replace(/-/g, "/");
        const newDate = new Date(newText);
        const day = newDate.getDate();
        const month = newDate.getMonth();
        const year = newDate.getFullYear();
        const monthName = this.months.find((el) => el.id === month);
        if (monthName) {
          date =
            (day < 10 ? `0${day}` : day) +
            " " +
            (this.min ? monthName.shortname : monthName.name) +
            " " +
            year;
        }
      }
      return date;
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.show-link {
  color: $red;
}
.history-wrapper {
  border: 1px dotted $border;
  padding: 2rem;

  .heading {
    // font-size: 1.8rem;
    font-weight: 700;
  }

  .date {
    // font-size: 1.4rem;
    font-weight: 600;
  }

  &__content {
    padding-bottom: 1rem;

    > p {
      padding-top: 0;
    }
  }
}
</style>
